/** The sunken fill of a well, without its corners, edge colour or focus states. */
export const WELL_FILL = 'bg-bg-well inset-ring-1 inset-shadow-well'

/** The well a text field sits in; it fills, turns blue and lights a halo on focus. */
export const FIELD_WELL = `rounded-4 ${WELL_FILL} transition-[background-color,box-shadow] duration-moderate ease-spring focus-within:bg-bg-primary focus-within:inset-shadow-none focus-within:ring-4`

/** Edge and halo of a well holding a value it accepts. */
export const FIELD_WELL_VALID =
  'inset-ring-border focus-within:inset-ring-accent-blue focus-within:ring-halo-blue'

/** Edge and halo of a well holding a value it refuses. The halo stays lit without focus. */
export const FIELD_WELL_INVALID = 'inset-ring-accent-red ring-4 ring-halo-red'

/** The hover edge of an enabled well. Focus keeps its blue edge under the pointer. */
export const FIELD_WELL_HOVER = 'not-focus-within:hover:inset-ring-border-strong'

export const FIELD_WELL_DISABLED = 'cursor-not-allowed opacity-40'

export const FIELD_TEXT =
  'bg-transparent text-body-medium text-text-primary caret-accent-blue outline-none placeholder:text-text-tertiary disabled:cursor-not-allowed'

/** A neutral key: a white surface with a light top edge. Pair it with an edge and `shadow-contact`. */
export const NEUTRAL_KEY = 'bg-bg-primary text-text-primary inset-ring-1 inset-shadow-glass-edge'

/** The hairline edge of a neutral key, darker under the pointer. */
export const NEUTRAL_KEY_EDGE = 'inset-ring-border hovered:inset-ring-border-strong'

/** A frosted key: the glass panel fill, blurred and saturated, with a light top edge and a hairline. Pair it with `GLASS_KEY_EDGE`, `GLASS_KEY_PRESS` and a shadow. */
export const GLASS_KEY =
  'bg-glass-panel text-text-primary backdrop-blur-glass backdrop-saturate-150 inset-ring-1 inset-shadow-glass-edge'

/** The hairline edge of a frosted key, darker under the pointer; the fill firms up too. */
export const GLASS_KEY_EDGE =
  'inset-ring-border hovered:inset-ring-border-strong hovered:bg-bg-primary/80'

/** A frosted key pressed in: a darker fill and the shadow gone inside. */
export const GLASS_KEY_PRESS =
  'pressed:bg-bg-tertiary/80 pressed:inset-shadow-well pressed:shadow-none'

/** A neutral key pressed in: a darker fill and the shadow gone inside. */
export const NEUTRAL_KEY_PRESS =
  'pressed:bg-bg-tertiary pressed:inset-shadow-well pressed:shadow-none'

/** A filled key: its own colour with a sheen, a light top edge and a pointer light. Pair it with a fill and `shadow-lift`. */
export const ACCENT_KEY =
  'bg-(image:--gradient-control-sheen) text-text-on-accent inset-shadow-control-light inset-ring-1 pointer-glow pointer-glow-on-accent pressed:bg-none pressed:inset-shadow-press pressed:shadow-none'

export const PRIMARY_KEY = `${ACCENT_KEY} bg-accent-blue inset-ring-accent-blue-active/30 pressed:bg-accent-blue-hover`

export const PRIMARY_KEY_SHADOW = 'shadow-lift shadow-accent-blue/30'
